/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Login_Invalid_TitleInputs */

const en_action_login_invalid_title = /** @type {(inputs: Action_Login_Invalid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login failed`)
};

const de_action_login_invalid_title = /** @type {(inputs: Action_Login_Invalid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Login failed" |
*
* @param {Action_Login_Invalid_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const action_login_invalid_title = /** @type {((inputs?: Action_Login_Invalid_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Login_Invalid_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_action_login_invalid_title(inputs)
	return en_action_login_invalid_title(inputs)
});